export const GOOGLE_WINDOW_FEATURES = {
    toolbar: 'no',
    location: 'no',
    width: 600,
    height: 850,
} as const;

export const OFFICE365_WINDOW_FEATURES = {
    toolbar: 'no',
    location: 'no',
    width: 600,
    height: 500,
} as const;

export const CALENDAR_BULLET_POINTS = [
    'Automatically send activities scheduled in Nutshell to your Google or Office 365 calendar',
    'Sync activities from your Google or Office 365 calendar into Nutshell',
    'Allow people to schedule meetings with you via Scheduler',
] as const;
